import React, { useState } from "react";
import { t, ui } from "../data/portfolio";

/*
 * Görsel yer tutucusu. Dosya yoksa ya da yüklenemezse kırık resim
 * göstermek yerine, hangi dosyanın beklendiğini söyleyen bir kutu çıkar.
 */
export default function Shot({ src, name, lang, ratio = "4 / 3", onClick, caption }) {
  const [failed, setFailed] = useState(!src);

  if (failed) {
    return (
      <div className="shot shot--empty" style={{ aspectRatio: ratio }}>
        <span className="shot-name">{name}</span>
        <code className="shot-path">{src || "/media/…"}</code>
        <span className="shot-hint">{ui[lang].placeholderImage}</span>
      </div>
    );
  }

  const image = (
    <img
      src={src}
      alt={caption ? `${name} — ${t(caption, lang)}` : name}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );

  if (onClick) {
    return (
      <button
        type="button"
        className="shot shot--button"
        style={{ aspectRatio: ratio }}
        onClick={onClick}
        aria-label={caption ? t(caption, lang) : name}
      >
        {image}
      </button>
    );
  }

  return (
    <div className="shot" style={{ aspectRatio: ratio }}>
      {image}
    </div>
  );
}
